import ApplicationActionTypes from 'redux/applications/types';

function transformCourses(payload) {
  const data = payload.data ? payload.data : payload;

  const groups = data.reduce((groups, item) => {
    groups[item.administrationLevelItem.name] = [
      ...(groups[item.administrationLevelItem.name] || []),
      item,
    ];
    return groups;
  }, {});

  const courses = [];

  /* eslint-disable */
  for (const prop in groups) {
    const children = groups[prop];
    const course = {
      value: children[0]?.administrationLevelItem.id,
      label: prop,
      children: children.map(({ title, id }) => ({
        value: id,
        label: title,
      })),
    };

    courses.push(course);
  }
  /* eslint-enable */

  return courses;
}

function addApplication(applications, application) {
  applications.unshift(application);

  return [...applications];
}

const initialState = {
  applications: { data: null },
  loading: true,
  saving: false,
  fetchingSingleApplication: false,
  currentApplication: null,
  addingApplicationData: undefined,
  deletingApplication: false,
  confirmModalOpen: false,
  selectedApplicationId: null,
  error: null,
  courses: [],
  filterOn: false,
  // candidate groups search result
  candidateGroupLoading: true,
  candidateGroup: [],
  selectedGroup: null,
  selectedGroups: [],
};

function applicationsReducer(state = initialState, { type, payload }) {
  switch (type) {
    case ApplicationActionTypes.SET_DATA:
      return {
        ...state,
        ...payload,
      };
    case ApplicationActionTypes.START_CREATE_APPLICATION:
    case ApplicationActionTypes.START_EDIT_APPLICATION:
      return {
        ...state,
        saving: true,
        loading: false,
        error: null,
      };
    case ApplicationActionTypes.START_FETCH_APPLICATIONS:
    case ApplicationActionTypes.START_FETCH_COURSES:
    case ApplicationActionTypes.START_APPLICATIONS_SEARCH:
    case ApplicationActionTypes.FILTER_APPLICATIONS:
      return {
        ...state,
        loading: true,
      };
    case ApplicationActionTypes.FILTER_APPLICATIONS_BY_GROUPS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case ApplicationActionTypes.ADD_APPLICATION_DATA:
      return {
        ...state,
        addingApplicationData: true,
      };

    case ApplicationActionTypes.CREATE_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        saving: false,
        applications: {
          ...state.applications,
          data: addApplication(state.applications.data, payload),
        },
      };
    case ApplicationActionTypes.EDIT_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        saving: false,
        addingApplicationData: false,
        applications: {
          ...state.applications,
          data: state.applications?.data?.map((application) =>
            application.id === payload.id ? payload : application
          ) || [],
        },
      };
    case ApplicationActionTypes.SEARCH_APPLICATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        applications: payload,
      };
    case ApplicationActionTypes.FETCH_APPLICATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        filterOn: false,
        applications: payload,
      };
    case ApplicationActionTypes.SEARCH_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        filterOn: true,
        applications: payload,
      };
    case ApplicationActionTypes.FETCH_COURSES_SUCCESS:
      return {
        ...state,
        loading: false,
        courses: transformCourses(payload),
      };
    case ApplicationActionTypes.CREATE_APPLICATION_FAILURE:
      return {
        ...state,
        saving: false,
        error: null,
      };
    case ApplicationActionTypes.EDIT_APPLICATION_FAILURE:
      return {
        ...state,
        saving: false,
        error: null,
      };
    case ApplicationActionTypes.FETCH_APPLICATIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: payload,
        // Keep table out of infinite skeleton: LoaderWrapper treats data===null as loading
        applications: { data: [], total: 0, totalPages: 0 },
      };
    case ApplicationActionTypes.FETCH_COURSES_FAILURE:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case ApplicationActionTypes.DELETE_APPLICATION_START:
      return {
        ...state,
        deletingApplication: true,
      };
    case ApplicationActionTypes.DELETE_APPLICATION_SUCCESS:
      return {
        ...state,
        deletingApplication: false,
        confirmModalOpen: false,
        selectedApplicationId: null,
        applications: {
          ...state.applications,
          data: state.applications.data.filter(
            (application) => application.id !== payload
          ),
        },
      };
    case ApplicationActionTypes.DELETE_APPLICATION_FAIL:
      return {
        ...state,
        deletingApplication: false,
        confirmModalOpen: false,
        selectedApplicationId: null,
      };
    case ApplicationActionTypes.OPEN_MODAL:
      return {
        ...state,
        confirmModalOpen: true,
        selectedApplicationId: payload,
      };
    case ApplicationActionTypes.CLOSE_MODAL:
      return {
        ...state,
        confirmModalOpen: false,
        selectedApplicationId: null,
      };
    case ApplicationActionTypes.START_FETCH_SINGLE_APPLICATIONS:
      return {
        ...state,
        fetchingSingleApplication: true,
      };
    case ApplicationActionTypes.FETCH_SINGLE_APPLICATIONS_SUCCESS:
      return {
        ...state,
        fetchingSingleApplication: false,
        currentApplication: payload,
      };
    case ApplicationActionTypes.FETCH_SINGLE_APPLICATIONS_FAILURE:
      return {
        ...state,
        fetchingSingleApplication: false,
      };

    case ApplicationActionTypes.SEARCH_CANDIDATE_GROUPS:
      return {
        ...state,
        candidateGroupLoading: true,
      };
    case ApplicationActionTypes.SEARCH_CANDIDATE_GROUPS_SUCCESS:
      return {
        ...state,
        candidateGroupLoading: false,
        candidateGroup: payload,
      };
    case ApplicationActionTypes.SEARCH_CANDIDATE_GROUPS_ERROR:
      return {
        ...state,
        candidateGroupLoading: false,
      };
    case ApplicationActionTypes.FETCH_SINGLE_GROUP:
      return {
        ...state,
        selectedGroups: []
      };
    case ApplicationActionTypes.FETCH_SINGLE_GROUP_SUCCESS:
      return {
        ...state,
        selectedGroups: payload,
      };
    case ApplicationActionTypes.FETCH_SINGLE_GROUP_ERROR:
      return {
        ...state,
        candidateGroupLoading: false,
      };
    default:
      return state;
  }
}

export default applicationsReducer;
